module.exports = __webpack_public_path__ + "assets/TrapezoidCut3Detailed.a2c3b48ece8cf1c79862f3207e875c42.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/TrapezoidCut3Detailed.png
// module id = 591
// module chunks = 0